import { Controller } from "@hotwired/stimulus";

const SUB_FORMS = {
  meetingNotes: ".interaction-detail__meeting-notes-form",
  completion: ".interaction-detail__completion-form",
  edit: ".interaction-detail__edit-form",
  scheduleFollowup: ".interaction-detail__schedule-followup-form",
};

// Shared behavior for the action row inside an .interaction-detail:
// each "show" swaps the actions row for one sub-form, each "hide" restores it.
// Subclassed by interaction-entry (inline timeline) and interaction-modal (index modal).
export default class extends Controller {
  showMeetingNotesForm(event) {
    this.showSubForm(event, "meetingNotes");
  }

  showCompletionForm(event) {
    this.showSubForm(event, "completion");
  }

  showEditForm(event) {
    this.showSubForm(event, "edit");
  }

  showScheduleFollowup(event) {
    this.showSubForm(event, "scheduleFollowup");
  }

  hideMeetingNotesForm(event) {
    this.hideSubForm(event);
  }

  hideCompletionForm(event) {
    this.hideSubForm(event);
  }

  hideEditForm(event) {
    this.hideSubForm(event);
  }

  hideScheduleFollowup(event) {
    this.hideSubForm(event);
  }

  // Inline edit-in-place for one note: swap the displayed body for its form.
  editNote(event) {
    const section = event.currentTarget.closest("[data-note-editable]");
    if (!section) return;
    const display = section.querySelector("[data-note-display]");
    const form = section.querySelector(".interaction-detail__note-form");
    if (!display || !form) return;

    display.style.display = "none";
    event.currentTarget.style.display = "none";
    form.style.display = "block";
    form.querySelector("textarea")?.focus();
  }

  cancelNoteEdit(event) {
    const section = event.currentTarget.closest("[data-note-editable]");
    if (!section) return;
    const display = section.querySelector("[data-note-display]");
    const form = section.querySelector(".interaction-detail__note-form");
    const editButton = section.querySelector(".interaction-detail__note-edit");

    if (form) form.style.display = "none";
    if (display) display.style.display = "";
    if (editButton) editButton.style.display = "";
  }

  // "Plan the next one" checkbox in the wrap-up form: reveals the follow-up
  // fields and enables them (a disabled fieldset is skipped on submit).
  togglePlanNext(event) {
    const fieldset = event.currentTarget.closest("form")?.querySelector(".completion-form__followup");
    if (!fieldset) return;
    fieldset.hidden = !event.currentTarget.checked;
    fieldset.disabled = !event.currentTarget.checked;
  }

  showSubForm(event, key) {
    const detail = event.currentTarget.closest(".interaction-detail");
    if (!detail) return;

    Object.values(SUB_FORMS).forEach((selector) => {
      const el = detail.querySelector(selector);
      if (el) el.style.display = "none";
    });

    const form = detail.querySelector(SUB_FORMS[key]);
    const actions = detail.querySelector(".interaction-detail__actions");
    if (form && actions) {
      form.style.display = "block";
      actions.style.display = "none";
      const textarea = form.querySelector("textarea");
      if (textarea) textarea.focus();
    }
  }

  hideSubForm(event) {
    const form = event.currentTarget.closest(Object.values(SUB_FORMS).join(","));
    const detail = event.currentTarget.closest(".interaction-detail");
    if (form) form.style.display = "none";
    const actions = detail?.querySelector(".interaction-detail__actions");
    if (actions) actions.style.display = "flex";
  }
}
